import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=45d74f45&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"
import style0 from "./Filters.vue?vue&type=style&index=0&id=45d74f45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d74f45",
  null
  
)

export default component.exports